import { useEffect, useState, useRef, useContext } from "react";
import { Context } from "../context/Context";
import { useNavigate } from "react-router-dom";

const Header = () => {
  const [solutionOpen, setSolutionOpen] = useState(false);
  const [resourcesOpen, setResourcesOpen] = useState(false);

  const solutionRef = useRef();
  const resourcesRef = useRef();

  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  const { dark, setDark, auth } = useContext(Context);
  const navigate = useNavigate();

  const [mobileSolutionsOpen, setMobileSolutionsOpen] = useState(false);
  const [mobileResourcesOpen, setMobileResourcesOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const closeMobileMenu = () => {
    setMenuOpen(false);
    setMobileSolutionsOpen(false);
    setMobileResourcesOpen(false);
  };

  const scrollToAyush = () => {
    closeMobileMenu();

    const section = document.getElementById("pre-consultation");

    if (section) {
      section.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    } else {
      navigate("/");

      setTimeout(() => {
        const ayushSection = document.getElementById("pre-consultation");

        if (ayushSection) {
          ayushSection.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }
      }, 700);
    }
  };

  useEffect(() => {
    const handler = (e) => {
      if (solutionRef.current && !solutionRef.current.contains(e.target)) {
        setSolutionOpen(false);
      }

      if (resourcesRef.current && !resourcesRef.current.contains(e.target)) {
        setResourcesOpen(false);
      }
    };

    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  return (
    <>
      <nav
        className={`fixed top-0 left-0 right-0 z-50 mx-auto px-6 py-5 flex justify-between items-center
        backdrop-blur-md transition-all duration-500 ease-in-out lg:rounded-full
        ${
          scrolled
            ? "lg:w-[800px] lg:bg-white/80 lg:dark:bg-[#0d0d0d]/80 lg:shadow-lg"
            : "lg:w-[80%] xl:w-[70%] 2xl:w-[60%] bg-transparent"
        }`}
      >
        {/* LOGO */}
        <div className="text-lg sm:text-xl font-semibold text-black dark:text-white flex items-center">
          <img
            onClick={() => {
              navigate("/");
              closeMobileMenu();
            }}
            src="../img/logoDarkUpdated.png"
            alt="Logo"
            className="inline-block w-8 sm:w-9 mr-2 -mt-1 cursor-pointer"
          />

          <span
            onClick={() => {
              navigate("/");
              closeMobileMenu();
            }}
            className="hidden lg:block cursor-pointer"
          >
            {scrolled ? "Clinical AI" : " Clinical AI Assistance"}
          </span>
        </div>

        {/* DESKTOP MENU */}
        <div className="hidden md:flex items-center gap-8 text-sm font-semibold text-gray-700 dark:text-gray-300">
          <NavItem onClick={() => navigate("/")} text="Home" />
          <NavItem onClick={() => navigate("/vision")} text="What & why" />

          <div className="relative" ref={solutionRef}>
            <button
              onClick={() => setSolutionOpen(!solutionOpen)}
              className="relative group"
            >
              Solutions
              <span className="absolute left-0 bottom-0 h-[2px] w-0 bg-blue-500 transition-all duration-300 group-hover:w-full"></span>
            </button>

            <div
              className={`absolute left-1/2 -translate-x-1/2 top-full mt-3 w-[90vw] max-w-[350px]
              bg-white dark:bg-[#0d0d0d]
              border border-gray-200 dark:border-white/10
              rounded-xl shadow-xl p-6
              transition-all duration-300
              ${
                solutionOpen
                  ? "opacity-100 translate-y-0"
                  : "opacity-0 translate-y-5 pointer-events-none"
              }`}
            >
              <MenuColumn
                title="SOLUTIONS"
                items={[
                  {
                    name: "Pre-Consultant",
                    description: "Pre-Consultant",
                    function: scrollToAyush,
                  },
                  {
                    name: "Pre-ConsultantVaani",
                    description: "Clinical-Scribe",
                    function: () =>
                      window.open(
                        "https://aayushvaani.clinicalaiassistance.com",
                        "_blank"
                      ),
                  },
                ]}
              />
            </div>
          </div>

          <div className="relative" ref={resourcesRef}>
            <button
              onClick={() => setResourcesOpen(!resourcesOpen)}
              className="relative group"
            >
              Resources
              <span className="absolute left-0 bottom-0 h-[2px] w-0 bg-blue-500 transition-all duration-300 group-hover:w-full"></span>
            </button>

            <div
              className={`absolute left-1/2 -translate-x-1/2 top-full mt-3 w-[90vw] max-w-[350px]
              bg-white dark:bg-[#0d0d0d]
              border border-gray-200 dark:border-white/10
              rounded-xl shadow-xl p-6
              transition-all duration-300
              ${
                resourcesOpen
                  ? "opacity-100 translate-y-0"
                  : "opacity-0 translate-y-5 pointer-events-none"
              }`}
            >
              <MenuColumn
                title="RESOURCES"
                items={[
                  {
                    name: "Blog",
                    description: "Latest updates",
                    link: "/blog",
                  },
                  {
                    name: "Contact Us",
                    description: "Get in touch",
                    link: "/contact",
                  },
                ]}
              />
            </div>
          </div>
        </div>

        {/* RIGHT */}
        <div className="hidden md:flex items-center gap-2 lg:gap-4">
          <button
            onClick={() => navigate("/auth")}
            className="px-4 lg:px-5 py-2 rounded-full bg-gradient-to-r from-[#106EE8] to-[#5F81E4] text-white shadow-lg hover:scale-105 transition"
          >
            {auth ? "Dashborad" : "Login"}
          </button>

          <button
            onClick={() => setDark(!dark)}
            className="px-3 py-1 border rounded-full dark:border-white/20"
          >
            {dark ? "☀️" : "🌙"}
          </button>
        </div>

        {/* MOBILE BUTTON */}
        <button
          onClick={() => setMenuOpen(!menuOpen)}
          className="md:hidden flex flex-col gap-1"
        >
          <span
            className={`w-6 h-[2px] bg-black dark:bg-white transition ${
              menuOpen ? "rotate-45 translate-y-[6px]" : ""
            }`}
          />
          <span
            className={`w-6 h-[2px] bg-black dark:bg-white transition ${
              menuOpen ? "opacity-0" : ""
            }`}
          />
          <span
            className={`w-6 h-[2px] bg-black dark:bg-white transition ${
              menuOpen ? "-rotate-45 -translate-y-[6px]" : ""
            }`}
          />
        </button>
      </nav>

      {/* MOBILE MENU */}
      <div
        className={`md:hidden fixed top-[72px] left-0 w-full z-[60]
        bg-white dark:bg-[#0d0d0d]
        border-t border-gray-200 dark:border-white/10
        overflow-hidden transition-all duration-300
        ${menuOpen ? "max-h-[800px]" : "max-h-0"}`}
      >
        <div className="px-6 py-6 flex flex-col gap-4 text-gray-700 dark:text-gray-300">
          <button
            onClick={() => {
              navigate("/");
              closeMobileMenu();
            }}
            className="text-left"
          >
            Home
          </button>

          <button
            onClick={() => {
              navigate("/vision");
              closeMobileMenu();
            }}
            className="text-left"
          >
            What & why
          </button>

          {/* SOLUTIONS */}
          <div>
            <button
              onClick={() => setMobileSolutionsOpen(!mobileSolutionsOpen)}
              className="w-full flex justify-between items-center"
            >
              Solutions
              <span>{mobileSolutionsOpen ? "−" : "+"}</span>
            </button>

            <div
              className={`overflow-hidden transition-all duration-300 ${
                mobileSolutionsOpen ? "max-h-[200px] mt-2" : "max-h-0"
              }`}
            >
              <div className="ml-4 flex flex-col gap-2 text-sm">
                <button onClick={scrollToAyush} className="text-left">
                  Pre-Consultant
                </button>

                <button
                  onClick={() => {
                    window.open(
                      "https://aayushvaani.clinicalaiassistance.com",
                      "_blank"
                    );
                    closeMobileMenu();
                  }}
                  className="text-left"
                >
                  Pre-ConsultantVaani
                </button>
              </div>
            </div>
          </div>

          {/* RESOURCES */}
          <div>
            <button
              onClick={() => setMobileResourcesOpen(!mobileResourcesOpen)}
              className="w-full flex justify-between items-center"
            >
              Resources
              <span>{mobileResourcesOpen ? "−" : "+"}</span>
            </button>

            <div
              className={`overflow-hidden transition-all duration-300 ${
                mobileResourcesOpen ? "max-h-[300px] mt-2" : "max-h-0"
              }`}
            >
              <div className="ml-4 flex flex-col gap-2 text-sm">
                <button
                  onClick={() => {
                    navigate("/blog");
                    closeMobileMenu();
                  }}
                  className="text-left"
                >
                  Blog
                </button>

                <button
                  onClick={() => {
                    navigate("/contact");
                    closeMobileMenu();
                  }}
                  className="text-left"
                >
                  Contact Us
                </button>
              </div>
            </div>
          </div>

          <button
            onClick={() => {
              navigate("/auth");
              closeMobileMenu();
            }}
            className="px-5 py-2 rounded-full bg-gradient-to-r from-[#106EE8] to-[#5F81E4] text-white"
          >
            {auth ? "Account" : "Login"}
          </button>

          <button
            onClick={() => setDark(!dark)}
            className="mt-2 px-4 py-2 rounded-lg bg-black text-white dark:bg-white dark:text-black"
          >
            Toggle Theme
          </button>
        </div>
      </div>
    </>
  );
};

export default Header;

function NavItem({ text, onClick }) {
  return (
    <button onClick={onClick} className="relative group">
      {text}
      <span className="absolute left-0 bottom-0 h-[2px] w-0 bg-blue-500 transition-all duration-300 group-hover:w-full"></span>
    </button>
  );
}

function MenuColumn({ title, items }) {
  const navigate = useNavigate();

  return (
    <div>
      <p className="text-xs text-gray-400 mb-4">{title}</p>

      {items.map((item, i) => (
        <div
          key={i}
          onClick={() => {
            if (item.function) item.function();
            if (item.link) navigate(item.link);
          }}
          className="p-3 rounded-lg hover:bg-gray-100 dark:hover:bg-white/5 transition cursor-pointer"
        >
          <p className="font-medium text-black dark:text-white">{item.name}</p>
          <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">
            {item.description}
          </p>
        </div>
      ))}
    </div>
  );
}